import React, { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { AnswerButtonV2 } from '~/shared/components/AnswerButtonV2'
import { Container } from '~/shared/components/Container'
import { Option } from '~/shared/components/Option'
import { PageTitle } from '~/shared/components/PageTitle'
import { OptionType } from '~/shared/constants'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types'

import { OPTION_VALUES, QUESTION } from './constants'

const Walking: React.FC<TPageProps> = ({ pageId, nextPagePath }) => {
  const { t } = useTranslation()
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    pageId,
    question: QUESTION,
    nextPagePath,
  })

  const optionProps = useMemo(
    () => ({
      name: pageId,
      type: OptionType.RADIO,
      onChange: (value: string) => {
        handleChange(value, handleContinue)
        setIsAnswersDisabled(true)
      },
    }),
    [pageId, handleChange, setIsAnswersDisabled, handleContinue],
  )

  return (
    <Container>
      <PageTitle marginBottom={24}>{t('onboarding.walking.title')}</PageTitle>
      <Option
        {...optionProps}
        marginBottom="12"
        disabled={isAnswersDisabled}
        value={OPTION_VALUES.LESS_TWENTY}
      >
        <AnswerButtonV2>
          <h3>{t('onboarding.walking.options.lessTwenty')}</h3>
        </AnswerButtonV2>
      </Option>
      <Option
        {...optionProps}
        marginBottom="12"
        disabled={isAnswersDisabled}
        value={OPTION_VALUES.TWENTY_SIXTY}
      >
        <AnswerButtonV2>
          <h3>{t('onboarding.walking.options.twentySixty')}</h3>
        </AnswerButtonV2>
      </Option>
      <Option
        {...optionProps}
        marginBottom="12"
        disabled={isAnswersDisabled}
        value={OPTION_VALUES.ONE_TWO_HOURS}
      >
        <AnswerButtonV2>
          <h3>{t('onboarding.walking.options.oneTwoHours')}</h3>
        </AnswerButtonV2>
      </Option>
      <Option
        {...optionProps}
        marginBottom="12"
        disabled={isAnswersDisabled}
        value={OPTION_VALUES.MORE_TWO_HOURS}
      >
        <AnswerButtonV2>
          <h3>{t('onboarding.walking.options.moreTwoHours')}</h3>
        </AnswerButtonV2>
      </Option>
    </Container>
  )
}

export default Walking
